import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Nav from './nav/Nav';
import Footer from './footer/Footer';
import { ToastContainer } from 'react-toastify';
import { LoadingPage } from 'src/components';
import { isRTL } from 'src/utils/global';


const MainLayout = () => {
    const { i18n } = useTranslation();
    const dir = isRTL() ? "rtl" : "ltr";

    useEffect(() => {
        document.documentElement.dir = dir;
        document.documentElement.lang = i18n.language;
    }, [dir, i18n.language]);

    return (
        <div dir={dir} className="flex min-h-full flex-col">
            <Nav />
            <main className="flex-1">
                <Suspense fallback={<LoadingPage />}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
            <ToastContainer closeButton={false} />
        </div>
    );
}
export default MainLayout;
